import WhatsAppIcon from "./WhatsAppIcon";
import { buildWhatsAppLink, WHATSAPP_CONSULTATION_MESSAGE } from "./FloatingWhatsAppButton";

/**
 * Reusable "QUESTIONS? CHAT WITH US NOW" WhatsApp callout
 * Used in: Pricing, Consultation, Application Form, Footer
 */
const WhatsAppCallout = ({
  variant = "default",
  phone = "+1 (619) 387-6711",
  message = WHATSAPP_CONSULTATION_MESSAGE,
}) => {
  const href = buildWhatsAppLink(message);

  if (variant === "compact") {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-callout-compact"
        className="inline-flex items-center gap-3 px-5 py-3 border border-[#D4AF37]/40 hover:border-[#D4AF37] bg-black/60 hover:bg-[#D4AF37]/[0.06] transition-all"
      >
        <span className="flex items-center justify-center w-8 h-8 rounded-full bg-[#25D366] text-white">
          <WhatsAppIcon size={16} />
        </span>
        <span className="text-left leading-tight">
          <span className="block text-[10px] text-[#D4AF37] tracking-[0.25em] uppercase">
            Questions?
          </span>
          <span className="block text-white text-sm font-semibold tracking-wide">
            Chat With Us · {phone}
          </span>
        </span>
      </a>
    );
  }

  return (
    <div
      className="relative max-w-3xl mx-auto bg-gradient-to-r from-[#0E0E0E] via-black to-[#0E0E0E] border border-[#D4AF37]/40 px-6 sm:px-10 py-6 sm:py-8"
      data-testid="whatsapp-callout"
    >
      <div className="absolute -top-px left-0 w-full h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />

      <div className="flex flex-col sm:flex-row items-center sm:items-start gap-5 sm:gap-7">
        <span className="flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-5px_rgba(37,211,102,0.5)] flex-shrink-0">
          <WhatsAppIcon size={26} />
        </span>
        <div className="text-center sm:text-left flex-1">
          <p className="text-[#D4AF37] text-xs tracking-[0.3em] uppercase mb-1">
            Questions?
          </p>
          <p
            className="font-display text-2xl sm:text-3xl text-white leading-tight mb-1"
            style={{ fontFamily: "'Bebas Neue', sans-serif" }}
          >
            CHAT WITH US NOW
          </p>
          <p className="text-white/60 text-sm tracking-wide">{phone}</p>
        </div>
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-[#D4AF37] text-black px-6 py-3 text-xs tracking-[0.2em] uppercase font-bold hover:bg-white transition-colors flex-shrink-0"
          data-testid="whatsapp-callout-btn"
        >
          Message Us
        </a>
      </div>
    </div>
  );
};

export default WhatsAppCallout;
